export var LifecycleEvent;
(function (LifecycleEvent) {
  LifecycleEvent[LifecycleEvent["TEST_READY"] = 1] = "TEST_READY";
  LifecycleEvent[LifecycleEvent["GAME_START"] = 2] = "GAME_START";
  LifecycleEvent[LifecycleEvent["INTERACT"] = 3] = "INTERACT";
  LifecycleEvent[LifecycleEvent["SCORE_CHANGED"] = 4] = "SCORE_CHANGED";
  LifecycleEvent[LifecycleEvent["GAME_END"] = 5] = "GAME_END";
  LifecycleEvent[LifecycleEvent["PAUSE_READY"] = 6] = "PAUSE_READY";
  LifecycleEvent[LifecycleEvent["GAME_PAUSE"] = 7] = "GAME_PAUSE";
  LifecycleEvent[LifecycleEvent["GAME_RESUME"] = 8] = "GAME_RESUME";
  LifecycleEvent[LifecycleEvent["GEMS_UPDATE"] = 9] = "GEMS_UPDATE";
})(LifecycleEvent || (LifecycleEvent = {}));